"use client";

import { useHistoryManager } from "../history/useHistoryManager";
import {
  getAccessPoint,
  getAccessPointId,
  getAccessPoints,
  getOrganisation,
} from "../slice/accessOrg-slice";
import { useAppSelector } from "../slice/hooks";

const BreadcrumbMenu = ({ sauce, setSearchTerm }) => {
  const { navigateTo } = useHistoryManager();
  const organisation = useAppSelector(getOrganisation);
  const accessPointId = useAppSelector(getAccessPointId);
  const accessPoint = useAppSelector(getAccessPoint);
  const accessPoints = useAppSelector(getAccessPoints);

  const goHome = () => {
    setSearchTerm("");
    navigateTo("home", {
      urlData: {
        organisation: organisation,
        accessPointId: accessPointId,
        accessPoint: accessPoint,
        accessPoints: accessPoints,
      },
    });
  };

  return (
    <div className="breadcrumbWrapper">
      <span className="breadcrumbItem" onClick={goHome}>
        Home
      </span>

      {sauce === "search" && (
        <>
          <span className="separator">›</span>
          <span className="breadcrumbItem active">Search Results</span>
        </>
      )}
    </div>
  );
};

export default BreadcrumbMenu;
